module.exports = __webpack_public_path__ + "front/img/27_6.c7a52778.png";